// extracted by mini-css-extract-plugin
export default {"wrapperBonusPack":"BonusPack_wrapperBonusPack__eUiiY","bonusWrapper":"BonusPack_bonusWrapper__c24MK","desktopWrapper":"BonusPack_desktopWrapper__CzXdF"};